import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import contentfolder from "../../../contentImgs/folder.png";
import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2,
    PenLineIcon} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import ContentFolderCard from "../ContentFolderCard";
import Toggle from "../../../UI/Toggle";
import FolderForQuiz from "./FolderForQuiz";
import { createNewMockTest } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import DesignColorAll from "../../CreateApp/DesignColorAll";
import ColorPicker from "../../../UI/ColorPicker/Colorpicker";
import AppTopMenuCard from "../../CreateApp/Cards/AppTopMenuCard";
import BasicInfoQuiz from "./BasicInfoQuiz";
import LanguageAndLabelsQuiz from "./LanguageAndLabelsQuiz";
import RevealAndRestrictQuiz from "./RevealAndRestrictQuiz";
import TestConfiguration from "./TestConfiguration";
import CustomCanvasConfetti from "../../../UI/Confetti";
import TestDesignSettings from "./TestDesignSettings";
import CreateSectionPopUp from "./CreateSectionPopUp";
import SectionsQuiz from "./SectionsQuiz";
import GetSectionDataByQuiz from "./GetSectionDataByQuiz";
import QuestionDashboard from "./QuestionDashboard";
import MockTest from "./TestInterface/MockTest";
import QuizThumbnail from "./QuizThumbnail";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const QuizSetUpOuter= ({closeQuizPopUp,quizObject,setQuizObjectDataBack})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
     
                 const [quizInfo, setQuizInfo] =useState(true);   
                 const [textTheme, setTextTheme] =useState(false);   
                 const [languageLabel, setLanguageLabel] =useState(false);   
                 const [revealAndRestrict, setRevealAndRestrict] =useState(false);   
                 const [testConfiguration, setTestConfiguration] =useState(false);  
                 const [footerTheme ,  setFooterTheme ] =useState(false);  
              
                           const [appTopMenuBarCard, setAppTopMenuBarCard] =useState(true);  
        const [sellAsTestSeries, setSellAsTestSeries] = useState(false);
  
        const [folderForQuizPopUp, setFolderForQuizPopUp] = useState(false);
        const [folderForQuizPopUpCreateFolder, setFolderForQuizPopUpCreateFolder] = useState(false);
        const [parentFolder, setParentFolder] = useState({ID:""});
       
        
        const [quizName, setQuizName] = useState("");
   const [quizID, setQuizID] = useState("");
   
      const [testInterfaceTheme, setTestInterfaceTheme] = useState();
      const [hideSectionBar, setHideSectionBar] = useState(true);
const [hideSectionPopUp, setHideSectionPopUp] = useState(true);
const [showQuestionsPopUp, setShowQuestionsPopUp] = useState(false);
const [showTestPreview, setShowTestPreview] = useState(false);
   
   const changeDurationType = ( durationType) => {
    
    //  const validityValue= { expiryDate:"",validityCount:itemArr?.validityValue?.validityCount,
    //    validityDurationType:durationType,lifeTimeValidity:true}
     
    setTestInterfaceTheme(durationType);
        // handleCreatePricePlan("durationValue",{validityCount:totalNo,durationType:durationType})
   };
     const colorPickerOptionArray =[     
                                 'rgba(255, 114, 94, 1)',      
                             'rgba(255, 114, 94, 0.5)', 
                                  
                           'rgba(255, 255, 255, 0.9)',    
                             'rgba(255, 114, 94, 0.1)'      
                             , 'rgba(55, 71, 79, 1)',       
                             'rgba(255, 193, 0, 1)'  ];
                     
                     
                             const [activeColorPickerValue,setActiveColorPickerValue]=useState('#99cc99')
                             const [themeColor ,setThemeColor] =useState({
                               primaryColor:'rgba(255, 204, 153,1)',
                                primaryColorOpacity5:'rgba(255, 204, 153,0.5)', 
                               buttonColor:'rgba(255, 204, 153,0.9)',
                               iconColorInfo:'rgba(83, 89, 103,0.9)', 
                                activityColor:'rgba(255, 204, 153,0.1)'});
                     
    const userdata = useSelector((state)=>state?.user?.user);
 
   
     const handleCreateNewMockTest=()=>{
     
     
     
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTest({testName:quizName,type:"mock",
         postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
         currentToken:currentToken?currentToken:"",
         editType:"",postId:"",menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){ 
           if(response?.quiz){
             
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
       
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
       
   
       return <>
       
   
 
   {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}

    

   
 <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99999,cursor:"pointer"}} onClick={()=>{}} className="appDesignPopUpOpacity"> </div>
    
            <div   className="AreYouSurePopUpThree" style={{borderRadius: '0px',}}>
              {!hideSectionBar?<div>
         {<div   className="SectionPopUpLeft " style={{borderRadius: '0px'}}> 
    <SectionsQuiz setHideSectionBar={()=>{setHideSectionBar(true)}}  parentID={quizObject?.postParent} quizObject={quizObject}   sendBackData={(data)=>{ }}/>



         </div>}</div>:""} 
   {!hideSectionPopUp?
       <GetSectionDataByQuiz setHideSectionPopUp={()=>{setHideSectionPopUp(true)}}  parentID={quizObject?.postParent} quizObject={quizObject} 
         sendBackData={(type,item)=>{
if(type=="goToDashboard"){
 
 setShowQuestionsPopUp(true);
 setHideSectionPopUp(true);
}if(type=="skipSection"){

 alert("selectQuesTypeOverAll")

}
  if(type=="sectionObject"){

 alert("selectQuesTypeForSection"+item?.sectionName)
 
}
          

          }}/>
:""}

    {showQuestionsPopUp?
     <QuestionDashboard  setShowQuestionsPopUp={()=>{setShowQuestionsPopUp(false)}}  parentID={quizObject?.postParent} quizObject={quizObject} />    :""}

     {showTestPreview?<MockTest quizObject={quizObject} setShowTestPreview={()=>{setShowTestPreview(false)}}/>:""}
 <div className="gridForWhatsNextAfterYT5 " style={{ position:"relative",padding:"5px",}}   >

                  <div className="QuizSetupTopLeft " style={{zIndex:"99",height:"59px", }} >
                    {hideSectionBar?<div  onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{ setHideSectionBar(false);   }}
               className="QuizAddSectionBtn"  >Show Sections </div>:""}
               
               <div onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{ 
 setShowQuestionsPopUp(true); }}
               className="QuizSetUpTopBtn"> + Create Questions </div> <div  onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{ setShowTestPreview(true)   }}
               className="QuizPreviewBtn"  > Preview Test </div></div> 
                <div className="QuizSetupTopRight" style={{ minHeight:"50px", position:"relative"}}  >

<div align="left" className="gridForTopSelectCOuseSetting" style={{borderRadius:"15px",paddingLeft:"20px",}} ><h3 className="ButtonWithEllipsis quizSetUpTitle"  >Test:{quizObject?.testName}</h3> 

</div>   
<div style={{background:"rgba(86, 82, 131,0.1)",width:"30px",height:"30px",borderRadius:"50%",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"15px",zIndex:99999,cursor:"pointer"}} onClick={()=>closeQuizPopUp(false)} ><X size={22}  color="rgb(86, 82, 131)"/></div> 


   </div>
     </div>
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"90%",overflowX:"hidden"}}>
<div className="quizSetUpMiddle " style={{ position:"relative",}}   >
    <div  style={{borderTop:"10px solid  rgba(144, 202, 249,0.11) ",padding:"5px",marginBottom:"45px"}}><AppTopMenuCard  activeCard={quizInfo}  icon={3} title ="Test Info" onClickPopup={
      ()=>{setQuizInfo(true);;setTextTheme(false);setLanguageLabel(false);;setRevealAndRestrict(false);setTestConfiguration(false)  ;setFooterTheme(false);setAppTopMenuBarCard(false); }} />

<AppTopMenuCard  activeCard={textTheme}  icon={4} title ="Quiz Thumbnail " onClickPopup={
      ()=>{setQuizInfo(false);;setTextTheme(true);setLanguageLabel(false);;setRevealAndRestrict(false);setTestConfiguration(false) ;setFooterTheme(false);setAppTopMenuBarCard(false);   }} />

<AppTopMenuCard  activeCard={languageLabel}  icon={2} title ="Language & Labels" onClickPopup={
      ()=>{setQuizInfo(false);;setTextTheme(false);setLanguageLabel(true);;setRevealAndRestrict(false);setTestConfiguration(false)  ;setFooterTheme(false) ;setAppTopMenuBarCard(false); }} />
<AppTopMenuCard  activeCard={testConfiguration}  icon={7} title ="Test Configuration" onClickPopup={
      ()=>{setQuizInfo(false);;setTextTheme(false);setLanguageLabel(false);;setRevealAndRestrict(false); setTestConfiguration(true) ;setFooterTheme(false) ;setAppTopMenuBarCard(false); }} />
<AppTopMenuCard  activeCard={revealAndRestrict}  icon={5} title ="Reveal & Restrict" onClickPopup={
      ()=>{setQuizInfo(false);;setTextTheme(false);setLanguageLabel(false);;setRevealAndRestrict(true);setTestConfiguration(false) ;setFooterTheme(false);setAppTopMenuBarCard(false);   }} />
<AppTopMenuCard  activeCard={footerTheme}  icon={6} title ="Test Theme & Design" onClickPopup={
      ()=>{setQuizInfo(false);;setTextTheme(false);setLanguageLabel(false);;setRevealAndRestrict(false); setTestConfiguration(false) ; setFooterTheme(true) ;setAppTopMenuBarCard(false); }} />
    </div>
<div  style={{borderTop:"10px solid  rgba(144, 202, 249,0.11) ",padding:"5px",marginBottom:"45px"}} >
    {quizInfo?<BasicInfoQuiz quizObjectID={quizObject?.ID} setQuizObjectDataBack={(data)=>{setQuizObjectDataBack(data)}} />:""}
   {textTheme?<QuizThumbnail quizObjectID={quizObject?.ID} setQuizObjectDataBack={(data)=>{setQuizObjectDataBack(data)}} />:""}

    {languageLabel?<LanguageAndLabelsQuiz  quizObjectID={quizObject?.ID} setQuizObjectDataBack={(data)=>{setQuizObjectDataBack(data)}} />:""}
    {revealAndRestrict?<RevealAndRestrictQuiz quizObjectID={quizObject?.ID} setQuizObjectDataBack={(data)=>{setQuizObjectDataBack(data)}} />:""}
    {testConfiguration?<TestConfiguration quizObjectID={quizObject?.ID} setQuizObjectDataBack={(data)=>{setQuizObjectDataBack(data)}} />:""}
    {footerTheme?<TestDesignSettings quizObjectID={quizObject?.ID} setQuizObjectDataBack={(data)=>{setQuizObjectDataBack(data)}} />  :""}
</div>
 
</div>
</div>

</div>
     </>


}
export default QuizSetUpOuter;